import { useQuery } from 'convex/react';
import { api } from '../../../convex/_generated/api';
import type { Id } from '../../../convex/_generated/dataModel';
import { useConvexMutation } from '../use-convex-mutation';

// Id is used by promote/revoke hooks below

export interface CoachSummary {
  id: string;
  email: string;
  createdAt: number;
  hasDirectorAccess: boolean;
}

export function useDirectorCoaches() {
  const data = useQuery(api.director.coaches.list);
  return { data, isLoading: data === undefined, error: null };
}

export function usePromoteToDirector() {
  const { mutateAsync, isPending } = useConvexMutation(api.director.coaches.promoteToDirector);
  return {
    isPending,
    mutateAsync: (coachId: string) =>
      mutateAsync({ coachUserId: coachId as Id<"users"> }),
  };
}

export function useRevokeDirectorAccess() {
  const { mutateAsync, isPending } = useConvexMutation(api.director.coaches.revokeDirectorAccess);
  return {
    isPending,
    mutateAsync: (coachId: string) =>
      mutateAsync({ coachUserId: coachId as Id<"users"> }),
  };
}
